import { Singleton } from "../Singletons/Singleton";

const language = new Singleton();

const VALIDATION_RESULT = {
    ERROR: 'error',
    RIGHT: 'right',
};

export function validatePasswords(password, newPassword, confirmPassword) {
    const validations = [
        {
            check: () => notEqualPassword(password, newPassword),
            errorKey: 'error-5003', 
        },
        {
            check: () => more8Characters(newPassword),
            errorKey: 'error-5002', 
        },
        {
            check: () => upperLowerNumber(newPassword),
            errorKey: 'error-5006', 
        },
        {
            check: () => newPassEqualsConfirmation(confirmPassword, newPassword),
            errorKey: 'error-5001', 
        },
    ];

    let isValid = true;
    const errorList = [];

    validations.forEach(({ check, errorKey }) => {
        if (check() === VALIDATION_RESULT.ERROR) {
            errorList.push(language.getText(errorKey));
            isValid = false;
        }
    });

    return {
        isValid,
        errors: errorList.join(', '),
    };
}

function notEqualPassword(password, newPassword) {
    return password && newPassword && password === newPassword
        ? VALIDATION_RESULT.ERROR
        : VALIDATION_RESULT.RIGHT;
}

function more8Characters(newPassword) {
    return newPassword && newPassword.length > 7
        ? VALIDATION_RESULT.RIGHT
        : VALIDATION_RESULT.ERROR;
}

function hasNumbers(str) {
    return /\d/.test(str);
}

function hasLowerCase(str) {
    return /[a-z]/.test(str);
}

function hasUpperCase(str) {
    return /[A-Z]/.test(str);
}


function upperLowerNumber(newPassword) {
    if (
        hasUpperCase(newPassword) &&
        hasLowerCase(newPassword) &&
        hasNumbers(newPassword)
    ) {
        return VALIDATION_RESULT.RIGHT;
    }
    return VALIDATION_RESULT.ERROR;
}

function newPassEqualsConfirmation(confirmPassword, newPassword) {
    return confirmPassword === newPassword
        ? VALIDATION_RESULT.RIGHT
        : VALIDATION_RESULT.ERROR;
}
